const SPECIES_BUCKETS = [
  { label: "Humpback", color: "#1E40AF", codes: ["HW"] },
  { label: "Fin", color: "#0D9488", codes: ["FW"] },
  { label: "Orca", color: "#111827", codes: ["NRKW", "BIGGS", "Oo"] },
  { label: "Other Marine Mammals", color: "#D97706", codes: ["DP", "HS", "SSL", "ES", "PWD"] },
  { label: "Vessels", color: "#BE185D", codes: ["SR", "LR", "R", "GITGAAT"] },
];

function bucketTotals(speciesCounts) {
  return SPECIES_BUCKETS.map((bucket) => ({
    label: bucket.label,
    color: bucket.color,
    count: (speciesCounts || [])
      .filter((entry) => bucket.codes.includes(entry.key))
      .reduce((sum, entry) => sum + entry.count, 0),
  }));
}

function bucketYearSeries(yearSpeciesCounts) {
  const rows = yearSpeciesCounts || [];
  const years = [...new Set(rows.map((row) => row.year))].sort((a, b) => a - b);
  const series = SPECIES_BUCKETS.map((bucket) => ({
    label: bucket.label,
    color: bucket.color,
    data: years.map((year) =>
      rows
        .filter((row) => row.year === year && bucket.codes.includes(row.species))
        .reduce((sum, row) => sum + row.count, 0)
    ),
  }));
  return { years, series };
}

function speciesColor(code) {
  const bucket = SPECIES_BUCKETS.find((entry) => entry.codes.includes(code));
  return bucket ? bucket.color : "#6B7280";
}

export default {
  SPECIES_BUCKETS,
  bucketTotals,
  bucketYearSeries,
  speciesColor,
};
